import { render } from "./UseCasesDetailsRWE.vue?vue&type=template&id=353f563b"
import script from "./UseCasesDetailsRWE.vue?vue&type=script&lang=js"
export * from "./UseCasesDetailsRWE.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__